module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "lista-imovel-card",
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.imovel.id
        }
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4 pb-4 lista_imoveis"
  }, [_c('v-layout', {
    staticStyle: {
      "min-height": "50px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "xl8": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [(_vm.exibirStatus) ? _c('span', {
    staticClass: "status_circulo",
    style: ({
      'background-color': _vm.statusColor
    })
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.imovel.apelido || _vm.fallbackTitulo))])]), _vm._v(" "), (_vm.formattedEndereco) ? _c('div', {
    staticClass: "grey--text text--darken-1 mt-1"
  }, [_vm._v("\n            " + _vm._s(_vm.formattedEndereco) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.imovel.tipo || _vm.imovel.proprietario) ? _c('div', {
    staticClass: "grey--text text--darken-1 mt-2"
  }, [(_vm.imovel.tipo) ? _c('span', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "caption secondary--text"
  }, [_c('strong', [_vm._v("Tipo")])]), _vm._v(" " + _vm._s(_vm.imovel.tipo))]) : _vm._e(), _vm._v(" "), (_vm.imovel.proprietario) ? _c('span', [_c('span', {
    staticClass: "caption secondary--text"
  }, [_c('strong', [_vm._v("Proprietário")])]), _vm._v(" " + _vm._s(_vm.imovel.proprietario))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view') || _vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "status-coluna",
    attrs: {
      "xs12": "",
      "md6": "",
      "xl4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.vistoriaSituacao) ? _c('ListaVistoriaSituacao', {
    attrs: {
      "situacao": _vm.vistoriaSituacao
    }
  }) : _c('v-btn', {
    staticClass: "secondary secondary--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [_vm._v("Sem vistoria")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "tarefas-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey grey--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [(_vm.tarefasPendentesCount === 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v("1  ")]), _vm._v("tarefa")] : (_vm.tarefasPendentesCount > 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.tarefasPendentesCount) + "  ")]), _vm._v("tarefas")] : [_vm._v("Sem tarefas")]], 2)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89a2f89e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Lista/ListaImovel.vue
// module id = 1036
// module chunks = 1